module.exports = __webpack_public_path__ + "prod/1.42.2/img/system-one-h5.4a1a9bdf.png";